// extracted by mini-css-extract-plugin
export default {"container":"component_form_checkbox_container__O3NWb","checkboxGroup":"component_form_checkbox_checkboxGroup__6eTBs"};